import { useEffect, useState } from "react";
import { getTalentNames, TalentName } from "../services/adminTalentNames";
import { withQuietRetry } from "../utils/adminRetry";

// The list behind an admin talent picker (the Requests filter, a venue's Add
// Talent). `talent` is every talent once the server answers; until then, or if
// the read fails after the quiet second try, it is the rows the dashboard has
// already loaded, and `partial` says the list may be short.
export function useTalentNames<T extends TalentName>(loaded: T[]) {
  const [all, setAll] = useState<TalentName[] | null>(null);
  const [partial, setPartial] = useState(false);

  useEffect(() => {
    let live = true;
    withQuietRetry(getTalentNames).then(
      (items) => {
        if (live) setAll(items);
      },
      () => {
        if (live) setPartial(true);
      }
    );
    return () => {
      live = false;
    };
  }, []);

  return { talent: (all ?? loaded) as TalentName[], partial };
}
